import React from "react";

export const ImagePreview = ({ dataUri, className, fileType }) => {
  return (
    <div className="justify-center flex">
      {fileType == "jpg" || fileType == "jpeg" ? (
          <img src={dataUri} className={className} />
      ) : fileType == "pdf" ? (
        <iframe
          src={dataUri}
          title="PDF preview"
          style={{ width: "100%", height: "100%" }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default ImagePreview;